import React from 'react'
import PaymentMethodListTable from './Components/PaymentMethodListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PaymentMethodList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Payment Method List</HeadingOne>
          <AddItemBtn url="add-payment-method" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <PaymentMethodListTable />
      </div>
    </PageBody>
  );
};

export default PaymentMethodList;
